/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ── Replace selected-value text with "Strap Guide" popup link in quick-add modals ──
     On the PDP, the size chart popup is rendered server-side via Liquid. In the
     quick-add modal that isn't available, so we replace the raw dimension text
     with a "Strap Guide" link that fetches the page content and shows it in a
     dialog, matching the PDP experience. */
  var strapGuidePageHandle = 'strap-guide-explained-popup';
  var strapGuideCache = null;

  function openStrapGuidePopup(e) {
    e.preventDefault();
    e.stopPropagation();

    // If we already have a dialog open, don't create another
    var existing = document.querySelector('.strap-guide-dialog');
    if (existing) {
      existing.showModal();
      return;
    }

    // Create and show the dialog
    var dialog = document.createElement('dialog');
    dialog.className = 'product-modal strap-guide-dialog';
    dialog.style.cssText = 'max-width: 600px; width: 90%; max-height: 85vh; border: none; border-radius: 10px; padding: 0; background: var(--bg, #fff); z-index: 9999;';
    dialog.innerHTML =
      '<div style="position: relative; padding: 30px; overflow-y: auto; max-height: 85vh;">' +
        '<button type="button" class="strap-guide-dialog__close" style="position: absolute; top: 12px; right: 12px; background: none; border: none; cursor: pointer; font-size: 24px; line-height: 1; padding: 4px 8px; color: inherit;" aria-label="Close">&times;</button>' +
        '<div class="strap-guide-dialog__body rte" style="padding-top: 10px;">Loading...</div>' +
      '</div>';

    document.body.appendChild(dialog);
    dialog.showModal();

    // Close handlers
    dialog.querySelector('.strap-guide-dialog__close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('click', function (evt) {
      if (evt.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      dialog.remove();
    });

    // Fetch page content (cache it so subsequent opens are instant)
    var body = dialog.querySelector('.strap-guide-dialog__body');
    if (strapGuideCache) {
      body.innerHTML = strapGuideCache;
      return;
    }

    fetch('/pages/' + strapGuidePageHandle)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        // Extract the main page content (Shopify wraps it in .rte or .page-content)
        var content = doc.querySelector('.rte') || doc.querySelector('.page-content') || doc.querySelector('.main-content') || doc.querySelector('main');
        if (content) {
          strapGuideCache = content.innerHTML;
          body.innerHTML = strapGuideCache;
        } else {
          body.innerHTML = '<p>Could not load strap guide content.</p>';
        }
      })
      .catch(function () {
        body.innerHTML = '<p>Could not load strap guide content.</p>';
      });
  }

  function replaceStrapValueWithGuide() {
    document.querySelectorAll('.product-quick-add__form [data-selected-value]').forEach(function (el) {
      if (el.hasAttribute('data-strap-guide-replaced')) return;
      var txt = el.textContent || '';
      if (/strap/i.test(txt)) {
        el.setAttribute('data-strap-guide-replaced', '');
        var link = document.createElement('a');
        link.href = '#';
        link.textContent = 'Strap Guide';
        link.style.cssText = 'text-decoration: underline; font-size: inherit; color: inherit; cursor: pointer;';
        link.addEventListener('click', openStrapGuidePopup);
        el.textContent = '';
        el.appendChild(link);
      }
    });
  }

  /* Initial run */
  replaceStrapValueWithGuide();

  /* Watch for any DOM changes (quick-add modals, variant re-renders, infinite scroll) */
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        replaceStrapValueWithGuide();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
